{
    "list_page__title": "Campagnes",
    "list_page__empty_state_title": "Aucune campagne pour le moment",
    "list_page__empty_state_description": "Faites la promotion d'articles auprès de clients sélectionnés – vos commerciaux reçoivent des tâches à ce sujet."
}
